<template>
  <el-drawer
    title="确认委托单"
    :visible.sync="showDrawer"
    :wrapperClosable="false"
    size="900px"
    class="drawer"
  >
    <div class="flex flex-center table-wrapper">
      <div class="border">
        <div class="head">
          <div class="head-name">{{ serve.checkmallWaresName }}</div>
          <!-- <div class="head-no">订单编号: {{ data.orderNo }}</div> -->
        </div>
        <div class="order">
          <TableForm
            :laboratory="laboratory"
            :order="order"
            @showProtocol="showProtocol"
            @confirmDeed="$emit('confirmDeed')"
          />
          <div class="tel">电话：027-83641671</div>
        </div>
      </div>
    </div>
    <div class="flex flex-center">
      <el-button type="primary" size="small" @click="printClick">
        打印委托协议</el-button
      >
    </div>
  </el-drawer>
</template>
<script>
import TableForm from "./TableForm.vue";
export default {
  components: {
    TableForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => ({}),
    },
    serve: {
      type: Object,
      default: () => ({}),
    },
    laboratory: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    showDrawer: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    showProtocol() {
      this.$jump.push({ name: "orderProtocol" });
    },
    // 点击打印按钮
    printClick() {
      this.$jump.push({ name: "deedPrint" });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.border {
  border: 1px solid #ddd;
  border-radius: 4px;
}
.head {
  width: 678px;
  border-bottom: 1px solid #ddd;
  padding: 20px 0;
  text-align: center;
  background: $head-bar-bg;
  &-name {
    font-size: 1.14rem;
    font-weight: 600;
    margin-bottom: 8px;
  }
  &-no {
    font-size: 12px;
    color: #999;
  }
}
.table-wrapper {
  margin-bottom: 15px;
}

.order {
  padding: 15px 10px;
}
.tel {
  text-align: right;
  padding-right: 2px;
}
.dialogP {
  /deep/ .el-dialog__body {
    padding: 5px 20px;
  }
  &-con {
    max-height: 500px;
    overflow: scroll;
  }
  &-title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-list {
    line-height: 25px;
    margin-bottom: 8px;
  }
  &-index {
    font-weight: bold;
    margin-right: 5px;
  }
}
</style>
